import { navigate } from "gatsby";
import React from "react";

const Layout_1 =({item})=>{
    const handleClick=(uri)=>{
        navigate(uri);
    }
    return(
        <div className="row mgt-5">
            <video autoPlay={true} muted="" id="video" controls={true}  style={{height:667}}>
                <source src={item[0].images} type="video/mp4"/>
            </video>  
        </div>
    )
}
const Layout_2 =({item})=>{
    const handleClick=(uri)=>{
        navigate(uri);
    }
    return(
        <div className="row mgt-5" style={{height:667}}>
            <video autoPlay={true} muted="" id="video" controls={true}  style={{height:667}}>
                <source src={item[0].images} type="video/mp4"/>
            </video>  
        </div>
    )
}

export {Layout_1,Layout_2}